import React, { PureComponent } from "react";
import { NavLink } from "react-router-dom";
import { WHITE, YELLOW } from "../colors";
import {
  PATH_USERS,
  PATH_MONITORING,
  PATH_RESEARCH,
  PATH_ORGANIZATIONS,
  getLink,
  PATH_ACCOUNT,
  PATH_IMPORTS,
} from "../../routes";
import styled from "styled-components";
import { userHasRole, ROLES } from "../../actions/auth";

import ResearchIcon from "react-icons/lib/md/find-in-page";
import UserIcon from "react-icons/lib/md/person";
import OrganizationsIcon from "react-icons/lib/md/business-center";
import MonitoringIcon from "react-icons/lib/md/track-changes";

import DocumentCollectionIcon from "react-icons/lib/md/library-books";

const StyledNavigation = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  a,
  .account {
    heigth: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${WHITE};
    padding: 20px;
    opacity: 0.5;
    text-decoration: none;
    &.active {
      border-bottom: 4px solid ${YELLOW};
      opacity: 1;
    }
    svg {
      margin-right: 5px;
    }
  }
  .account {
    margin-left: auto;
  }
`;

export default class Navigation extends PureComponent {
  render() {
    const { user } = this.props;
    return (
      <StyledNavigation className="navigation">
        <NavLink activeClassName={"active"} to={getLink(PATH_MONITORING)}>
          <MonitoringIcon />
          Monitoring
        </NavLink>
        <NavLink activeClassName={"active"} to={getLink(PATH_RESEARCH)}>
          <ResearchIcon />
          Recherchen
        </NavLink>
        {userHasRole(user, [
          ROLES.ADMIN,
          ROLES.WORKSPACEADMIN,
          ROLES.ORGANIZATIONADMIN,
        ]) && (
          <NavLink activeClassName={"active"} to={getLink(PATH_USERS)}>
            <UserIcon /> Benutzer
          </NavLink>
        )}
        {userHasRole(user, [ROLES.ADMIN, ROLES.WORKSPACEADMIN]) && (
          <NavLink activeClassName={"active"} to={getLink(PATH_ORGANIZATIONS)}>
            <OrganizationsIcon />
            Unternehmen
          </NavLink>
        )}
        {userHasRole(user, [ROLES.ADMIN, ROLES.WORKSPACEADMIN]) && (
          <NavLink activeClassName={"active"} to={getLink(PATH_IMPORTS)}>
            <DocumentCollectionIcon />
            Imports
          </NavLink>
        )}
        {user && (
          <div className="account">
            <NavLink activeClassName={"active"} to={getLink(PATH_ACCOUNT)}>
              {user.email}
            </NavLink>
          </div>
        )}
      </StyledNavigation>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/navigation.js